"use client";

import Image from "next/image";
import Button from "../../ui/Button";
import Link from "next/link";
import Breadcrumbs from "@/components/ui/Breadcrumbs";

export default function SamedayHeroSection() {
  return (
    <section
      className="w-full max-w-none"
      aria-labelledby="sameday-hero-heading"
    >
      <div className="w-full">
        <Breadcrumbs
          items={[
            { label: "How delivery works", href: "/how-delivery-works" },
            { label: "Same-day delivery" },
          ]}
        />

        <div className="grid gap-6 lg:grid-cols-2 lg:items-center lg:gap-12">
          {/* Image, shown first on mobile, second on desktop */}
          <div
            className="relative order-first w-full aspect-[600/450] overflow-hidden rounded-2xl border border-blue-80/20 bg-blue-5 sm:rounded-2xl lg:order-last"
          >
            <Image
              src="/media/pages/sameday-delivery/truck-bg.webp"
              alt=""
              fill
              className="object-cover object-center"
              sizes="(max-width: 1024px) 100vw, 50vw"
              priority
              aria-hidden
            />
            <div className="pointer-events-none absolute inset-0 overflow-hidden">
              <div className="absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 scale-[1.2]">
                <div className="relative h-full w-full">
                  <Image
                    src="/media/pages/sameday-delivery/truck.webp"
                    alt="Dank Cannabis delivery van"
                    fill
                    className="object-contain object-center drop-shadow-lg"
                    sizes="(max-width: 1024px) 100vw, 50vw"
                    priority
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Text content */}
          <div className="min-w-0 lg:order-first">
            <h1
              id="sameday-hero-heading"
              className="text-h2-mobile lg:text-h2-desktop font-bold leading-tight text-text-primary"
            >
              Your next favorite strain is here
            </h1>
            <p className="mt-4 text-body-16-desktop leading-relaxed text-text-secondary">
              Browse the Dank catalog to explore our full weed lineup, from classic strains to fresh drops.
            </p>
            <div className="mt-8">
              <Button asChild variant="brand" size="lg" className="w-full sm:w-auto rounded-xl px-6 py-3">
                <Link href="/search">
                  Same day delivery
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
